var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccomodation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.12,
    height: 36.534,
    opacity: 0.75,
    viewBox: "0 0 37.12 36.534",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230",
    transform: "translate(-16.223 -268.74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201",
    transform: "translate(16.473 269.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188",
    transform: "translate(8.116 11.675)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M616.217,783.025H596.972a.571.571,0,0,1-.572-.572V759.272a.572.572,0,0,1,1.144,0v22.609h18.1V759.272a.572.572,0,0,1,1.144,0v23.181A.574.574,0,0,1,616.217,783.025Z",
    transform: "translate(-596.4 -758.7)",
    fill: "#1c474a",
    stroke: "#1c474a",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187",
    transform: "translate(2.551 5.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M706.986,979.658h-3.014a.571.571,0,0,1-.572-.572v-3.014a.571.571,0,0,1,.572-.572h3.014a.571.571,0,0,1,.572.572v3.014A.572.572,0,0,1,706.986,979.658Zm-2.441-1.144h1.869v-1.869h-1.869Z",
    transform: "translate(-703.4 -975.5)",
    fill: "#1c474a",
    stroke: "#1c474a",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M940.386,979.658h-3.014a.571.571,0,0,1-.572-.572v-3.014a.571.571,0,0,1,.572-.572h3.014a.571.571,0,0,1,.572.572v3.014A.574.574,0,0,1,940.386,979.658Zm-2.441-1.144h1.869v-1.869h-1.869v1.869Z",
    transform: "translate(-931.235 -975.5)",
    fill: "#1c474a",
    stroke: "#1c474a",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M940.386,979.658h-3.014a.571.571,0,0,1-.572-.572v-3.014a.571.571,0,0,1,.572-.572h3.014a.571.571,0,0,1,.572.572v3.014A.574.574,0,0,1,940.386,979.658Zm-2.441-1.144h1.869v-1.869h-1.869v1.869Z",
    transform: "translate(-931.235 -975.5)",
    fill: "#1c474a",
    stroke: "#1c474a",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M1173.786,979.658h-3.013a.571.571,0,0,1-.572-.572v-3.014a.571.571,0,0,1,.572-.572h3.013a.571.571,0,0,1,.572.572v3.014A.574.574,0,0,1,1173.786,979.658Zm-2.441-1.144h1.869v-1.869h-1.869Z",
    transform: "translate(-1159.071 -975.5)",
    fill: "#1c474a",
    stroke: "#1c474a",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193",
    transform: "translate(27.36 15.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M1412.288,944.189h-8.116a.571.571,0,0,1-.572-.572V924.372a.571.571,0,0,1,.572-.572h8.116a.571.571,0,0,1,.572.572v19.245A.572.572,0,0,1,1412.288,944.189Zm-7.543-1.144h6.971v-18.1h-6.971Z",
    transform: "translate(-1403.6 -923.8)",
    fill: "#1c474a",
    stroke: "#1c474a",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_192",
    "data-name": "Group 192",
    transform: "translate(2.551 2.551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M1514.186,1034.958h-3.014a.571.571,0,0,1-.572-.572v-3.014a.571.571,0,0,1,.572-.572h3.014a.571.571,0,0,1,.572.572v3.014A.574.574,0,0,1,1514.186,1034.958Zm-2.441-1.144h1.869v-1.869h-1.869Z",
    transform: "translate(-1510.6 -1030.8)",
    fill: "#1c474a",
    stroke: "#1c474a",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190",
    transform: "translate(0 5.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M1514.186,1268.358h-3.014a.571.571,0,0,1-.572-.572v-3.014a.571.571,0,0,1,.572-.572h3.014a.571.571,0,0,1,.572.572v3.014A.574.574,0,0,1,1514.186,1268.358Zm-2.441-1.145h1.869v-1.869h-1.869Z",
    transform: "translate(-1510.6 -1264.2)",
    fill: "#1c474a",
    stroke: "#1c474a",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191",
    transform: "translate(0 11.129)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M1514.186,1501.758h-3.014a.571.571,0,0,1-.572-.572v-3.014a.571.571,0,0,1,.572-.572h3.014a.571.571,0,0,1,.572.572v3.014A.574.574,0,0,1,1514.186,1501.758Zm-2.441-1.144h1.869v-1.869h-1.869Z",
    transform: "translate(-1510.6 -1497.6)",
    fill: "#1c474a",
    stroke: "#1c474a",
    strokeWidth: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198",
    transform: "translate(0 15.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M264.688,944.189h-8.116a.571.571,0,0,1-.572-.572V924.372a.571.571,0,0,1,.572-.572h8.116a.571.571,0,0,1,.572.572v19.245A.572.572,0,0,1,264.688,944.189Zm-7.543-1.144h6.971v-18.1h-6.971Z",
    transform: "translate(-256 -923.8)",
    fill: "#1c474a",
    stroke: "#1c474a",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197",
    transform: "translate(2.551 2.551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_194",
    "data-name": "Group 194",
    transform: "translate(0 11.129)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M366.586,1501.758h-3.014a.571.571,0,0,1-.572-.572v-3.014a.571.571,0,0,1,.572-.572h3.014a.571.571,0,0,1,.572.572v3.014A.574.574,0,0,1,366.586,1501.758Zm-2.441-1.144h1.869v-1.869h-1.869Z",
    transform: "translate(-363 -1497.6)",
    fill: "#1c474a",
    stroke: "#1c474a",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_195",
    "data-name": "Group 195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M366.586,1034.958h-3.014a.571.571,0,0,1-.572-.572v-3.014a.571.571,0,0,1,.572-.572h3.014a.571.571,0,0,1,.572.572v3.014A.574.574,0,0,1,366.586,1034.958Zm-2.441-1.144h1.869v-1.869h-1.869Z",
    transform: "translate(-363 -1030.8)",
    fill: "#1c474a",
    stroke: "#1c474a",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196",
    transform: "translate(0 5.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M366.586,1268.358h-3.014a.571.571,0,0,1-.572-.572v-3.014a.571.571,0,0,1,.572-.572h3.014a.571.571,0,0,1,.572.572v3.014A.574.574,0,0,1,366.586,1268.358Zm-2.441-1.145h1.869v-1.869h-1.869Z",
    transform: "translate(-363 -1264.2)",
    fill: "#1c474a",
    stroke: "#1c474a",
    strokeWidth: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199",
    transform: "translate(10.667 22.408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M706.986,1213.058h-3.014a.571.571,0,0,1-.572-.572v-3.014a.571.571,0,0,1,.572-.572h3.014a.571.571,0,0,1,.572.572v3.014A.572.572,0,0,1,706.986,1213.058Zm-2.441-1.144h1.869v-1.869h-1.869Z",
    transform: "translate(-703.4 -1208.9)",
    fill: "#1c474a",
    stroke: "#1c474a",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M940.386,1213.058h-3.014a.571.571,0,0,1-.572-.572v-3.014a.571.571,0,0,1,.572-.572h3.014a.571.571,0,0,1,.572.572v3.014A.574.574,0,0,1,940.386,1213.058Zm-2.441-1.144h1.869v-1.869h-1.869v1.869Z",
    transform: "translate(-931.235 -1208.9)",
    fill: "#1c474a",
    stroke: "#1c474a",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M940.386,1213.058h-3.014a.571.571,0,0,1-.572-.572v-3.014a.571.571,0,0,1,.572-.572h3.014a.571.571,0,0,1,.572.572v3.014A.574.574,0,0,1,940.386,1213.058Zm-2.441-1.144h1.869v-1.869h-1.869v1.869Z",
    transform: "translate(-931.235 -1208.9)",
    fill: "#1c474a",
    stroke: "#1c474a",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M1173.786,1213.058h-3.013a.571.571,0,0,1-.572-.572v-3.014a.571.571,0,0,1,.572-.572h3.013a.571.571,0,0,1,.572.572v3.014A.574.574,0,0,1,1173.786,1213.058Zm-2.441-1.144h1.869v-1.869h-1.869Z",
    transform: "translate(-1159.071 -1208.9)",
    fill: "#1c474a",
    stroke: "#1c474a",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200",
    transform: "translate(14.76 28.082)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M881.628,1454.818h-5.956a.571.571,0,0,1-.572-.572v-6.773a.571.571,0,0,1,.572-.572h5.958a.571.571,0,0,1,.572.572v6.773A.576.576,0,0,1,881.628,1454.818Zm-5.383-1.144h4.814v-5.629h-4.814Z",
    transform: "translate(-875.1 -1446.9)",
    fill: "#1c474a",
    stroke: "#1c474a",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M1000.572,1454.818a.571.571,0,0,1-.572-.572v-6.773a.572.572,0,0,1,1.144,0v6.773A.572.572,0,0,1,1000.572,1454.818Z",
    transform: "translate(-997.022 -1446.9)",
    fill: "#1c474a",
    stroke: "#1c474a",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M901.492,635.284a2.992,2.992,0,1,1,2.992-2.992A3,3,0,0,1,901.492,635.284Zm0-4.84a1.848,1.848,0,1,0,1.848,1.848A1.851,1.851,0,0,0,901.492,630.444Z",
    transform: "translate(-883.182 -620.711)",
    fill: "#1c474a",
    stroke: "#1c474a",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M481.708,282.957h-.033a.565.565,0,0,1-.393-.191l-1.535-1.721a.573.573,0,0,1,.045-.808L492.2,269.17a.575.575,0,0,1,.763,0l12.407,11.067a.571.571,0,0,1,.045.808l-1.535,1.721a.57.57,0,0,1-.393.191.557.557,0,0,1-.412-.145l-10.49-9.358-10.493,9.358A.565.565,0,0,1,481.708,282.957Zm-.727-2.248.775.868,10.443-9.315a.575.575,0,0,1,.763,0l10.443,9.315.775-.868-11.6-10.347Z",
    transform: "translate(-474.27 -269.025)",
    fill: "#1c474a",
    stroke: "#1c474a",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccomodation);
export default __webpack_public_path__ + "static/media/accomodation.b2265bbe5dcc3dcc9f1aa5b2bb51ea31.svg";
export { ForwardRef as ReactComponent };